module.exports = __webpack_public_path__ + "static/media/Icon - smart lighting .62c58da1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements/Icon - smart lighting .svg
// module id = 44
// module chunks = 0